import { IWatchFullInfoContext } from './watchFullInfoContext';

export enum WatchFullInfoActionTypes {
	SET_WATCH_FULL_INFO = 'SET_WATCH_FULL_INFO',
	SET_DATA_FOR_PUSH = 'SET_DATA_FOR_PUSH',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetWatchFullInfo {
	type: WatchFullInfoActionTypes.SET_WATCH_FULL_INFO;
	payload: {
		watchFullInfo: IWatchFullInfoContext['watchFullInfo'];
	};
}

interface ISetDataForPush {
	type: WatchFullInfoActionTypes.SET_DATA_FOR_PUSH;
	payload: {
		dataForPush: IWatchFullInfoContext['dataForPush'];
	};
}
interface IChangeTypeOfModalWindow {
	type: WatchFullInfoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IWatchFullInfoContext['typeOfModalWindow'];
	};
}

export type TWatchFullInfoAction = ISetWatchFullInfo | ISetDataForPush | IChangeTypeOfModalWindow;
